import { Modal } from "antd";
import { useCallback } from "react";
import { FormattedMessage } from "react-intl";
import DiscountCodeForm from "views/DiscountCodes/DiscountCodeCreate/partials/DiscountCodeForm";

import { DiscountCodeFormModalProps } from "./types";
import { useDiscountCodeForm } from "./hooks";

const DiscountCodeFormModal: React.FC<DiscountCodeFormModalProps> = ({
  onFinish,
  ...props
}) => {
  const formProps = useDiscountCodeForm({ onFinish });

  const afterCloseHandler = useCallback(() => {
    formProps.form.resetFields();
  }, [formProps.form]);

  return (
    <Modal
      title={<FormattedMessage defaultMessage="Add New Discount Code" />}
      footer={null}
      width={800}
      destroyOnClose
      afterClose={afterCloseHandler}
      {...props}
    >
      <DiscountCodeForm {...formProps} />
    </Modal>
  );
};

export default DiscountCodeFormModal;
